import { GoalStatusEnum, type Goal } from "@features/api/TrackerApi";
import { filterPlanPendingGoals } from "@/src/hooks/plan/filterPlanInactiveTodos";

/**
 * 起步清单「Activate your goal」落点（Figma `109640:104546` 所在 Activate goal 分支图）：
 * - `create`：没有待激活 goal（跳过 onboarding）→ Chat 新建 goal
 * - `detail`：只有一个 → 该 goal 的 Plan overview（`/goal/{id}`；页面按 PLANNED / INACTIVE
 *   自行展示 Activate goal / Refine with Ed）
 * - `select`：多个 → `/activate-goal` 选择页
 */
export type ActivateGoalTarget =
  | { kind: "create" }
  | {
      kind: "detail";
      goalId: string;
      /** PLANNED = 已细化（Plan overview · refined）；INACTIVE = 未细化（unrefined），埋点 state 用 */
      refined: boolean;
    }
  | { kind: "select"; pendingCount: number };

/**
 * 口径与选择页（`usePendingActivateGoals`）一致：INACTIVE + PLANNED，去掉当日已滑走的 ——
 * 否则这里数出 2 个、选择页只显示 1 个。
 */
export function resolveActivateGoalTarget(
  goals: Goal[],
  skippedIds: ReadonlySet<string> = new Set(),
): ActivateGoalTarget {
  const pending = filterPlanPendingGoals(goals).filter(
    (goal) => !skippedIds.has(goal.id),
  );
  if (pending.length === 0) {
    return { kind: "create" };
  }
  if (pending.length === 1) {
    return {
      kind: "detail",
      goalId: pending[0].id,
      refined: pending[0].status === GoalStatusEnum.PLANNED,
    };
  }
  return { kind: "select", pendingCount: pending.length };
}
